import { useMutation } from '@tanstack/react-query'

import { addRampCurve } from '@/features/resource/endpoints/resources'
import type { AddRampCurveRequest } from '@/features/resource/types'

export function useAddRampCurveMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: AddRampCurveRequest) => addRampCurve(resourceId, data),
  })

  return {
    addRampCurve: mutateAsync,
    ...mutationResult,
  }
}
